import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ICreateCollectionBody } from './create-collection-request';
import type { ICreateCollectionResponse } from './create-collection-response';
import { createCollectionResponseSchema } from './create-collection-response';

export async function createCollectionApi(
  body: ICreateCollectionBody,
): Promise<IValidatedResponse<ICreateCollectionResponse>> {
  return postRequest<ICreateCollectionResponse>({
    path: '/sys/collections',
    body,
    schema: createCollectionResponseSchema,
  });
}
